import React from 'react'
import ReactDOM from 'react-dom'
import {Portal} from 'react-portal'
import assign from 'lodash/assign'
import createReactClass from 'create-react-class'


var BatchModal = createReactClass({
	stopClick: function(event) {
		event.stopPropagation();
	},
	render: function() {
		var self = this;
		var className = "modal";

		if (this.props.className) {
			className += " " + this.props.className;
		}

		var style = {
			display: (this.props.show ? 'flex' : 'none')
		};

		if (this.props.style) {
			style = assign({}, style, this.props.style);
		}

		var contentStyle = {}

		if (this.props.contentStyle) {
			contentStyle = assign({}, contentStyle, this.props.contentStyle)
		}


		return (
			<Portal isOpened={this.props.show}>
				<div className={className} style={style} id={this.props.id}>
					<div className="modal-content" style={contentStyle}>
						{this.props.children}
						<a className="modal-close" onClick={function () { self.props.closeCallback() }}>×</a>
					</div>
				</div>
			</Portal>
		);
	}
});

export default BatchModal;
